// AI-CONTEXT: See docs/features/impact-in-beeld-fase2.md

/**
 * URL van de publieke impactpagina. Zonder slug: de org-pagina; met slug: de
 * productpagina. Markeringen: `scan` (QR-doelen — alleen echte scans tellen),
 * `live` (kassascherm — pagina pollt de totalen) en `embed` (compacte
 * widget-weergave voor iframes).
 *
 * @param {object} input
 * @param {string} input.client - Tenant-CompagnyID (URL-segment)
 * @param {string} [input.slug] - Product-slug voor de productpagina
 * @param {boolean} [input.scan] - Voeg de scan-markering toe (QR-doelen)
 * @param {boolean} [input.live] - Voeg de live-markering toe (kassascherm-polling)
 * @param {boolean} [input.embed] - Voeg de embed-markering toe (compacte weergave)
 * @param {string} [input.origin] - Absolute origin voor QR-codes/embeds (bv. https://app.deccos.nl)
 * @returns {string} pad of absolute URL
 */
const impactPageUrl = ({ client, slug, scan = false, live = false, embed = false, origin = '' } = {}) => {
    const path = slug ? `/${client}/impactopen/${slug}` : `/${client}/impactopen`

    const params = [
        scan && 'scan=1',
        live && 'live=1',
        embed && 'embed=1',
    ].filter(Boolean)
    const query = params.length > 0 ? `?${params.join('&')}` : ''

    return `${origin}${path}${query}`
}

export { impactPageUrl }
